var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironmentGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9,
    y1: 6.5,
    x2: 11,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3aecfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#494de6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6,
    x2: 8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3,
    x2: 5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    x2: 14,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.5,5.5l.08.06c.61.44.92.67.92.94s-.31.5-.92.94l-.08.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,3.5l-.5,3-.5,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.5,5.5l-.08.06c-.61.44-.92.67-.92.94s.31.5.92.94l.08.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.5,6.5c0,2.83,0,4.24-.95,5.12-.95.88-2.48.88-5.55.88s-4.6,0-5.55-.88c-.95-.88-.95-2.29-.95-5.12S.5,2.26,1.45,1.38c.95-.88,2.48-.88,5.55-.88s4.6,0,5.55.88c.63.58.84,1.41.92,2.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentGradient);
export default __webpack_public_path__ + "static/media/Environment Gradient.4bd54f359ba80c442cae113fc56c679e.svg";
export { ForwardRef as ReactComponent };